export const COREPORT_GOOGLE_URL =
  'https://chrome.google.com/webstore/detail/coreport/gfngafojheogjoohidocheiojcijdbbo';

export const CONTACT_US_URL = 'mailto:support@wall.money';

export const GENERATE_PAY_TO_URL = 'https://payto.money';
